import csiAction from "csi/action";
import Popup from "csi/action/Popup";
import def from "csi/def";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ViewRef from "csi/def/ViewRef";
import Renderer from "csi/heading/Renderer";
import html from "csi/html";
import locale from "csi/locale";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import declare from "dojo/_base/declare";
import _ from "underscore";

export = declare(Renderer, {

	/**
	 * @override
	 * Draw popup icon for Proof task or link for Camunda task
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement, _params) {
		const node = ctx.getNode();
		const cache = ctx.cache;

		if (node.$Type == "ProofTask") {
			const revisionNode = cache.getNode(node.C8Instance);
			if (revisionNode) {
				const proofWorkflowInstance = cache.getNode(revisionNode.ProofWorkflow);
				if (proofWorkflowInstance) {
					html.create("span", {
						innerText: locale.resource("Proofing"),
					}, refNode);

					new TextWithMaterialIcon({
						class: "csi-flex-inline",
						icon: (ctx.bExcel || ctx.bPrint) ? "" : "open_in_new",
						iconOnly: true,
						onClick: (): void => {
							const action = _.extend(new Popup(), {
								m_id: "PopupProofProgress",
								m_viewRef: _.extend(new ViewRef(), {
									m_id: "ProofProgress",
									m_url: proofWorkflowInstance.$URL,
								}),
							});
							action.resolve();
							csiAction.invoke(ctx.view, refNode, action);
						},
					}).placeAt(refNode);
				}
			}
		} else if (node.$Type == "CamundaTask") {
			const camundaProcessDefinitionRevision = cache.getNode(node.ProcessDefinition);
			const camundaProcessDefinition = cache.getNode(camundaProcessDefinitionRevision.__Parent__);
			const anchor = def.createBrowseAnchor(ctx, refNode, camundaProcessDefinition);
			html.text(anchor || refNode, camundaProcessDefinition.$Name);
		}
	},
});
